var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4253.11,-2.37891 H -1.11328 V 4252 H 4253.11 V -2.37891",
    style: {
      fill: "#cf9615",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 794.516,3155.36 H 557.93 v 40.48 c 0,67.02 24.058,92.35 60.718,131.57 l 92.321,97.4 c 74.64,79.7 91.109,130.3 91.109,216.37 v 83.5 c 0,122.68 -59.48,180.92 -188.515,180.92 -126.473,0 -191.02,-67.07 -191.02,-187.28 v -103.68 h 131.59 v 107.53 c 0,51.81 25.301,67.05 55.687,67.05 27.782,0 51.836,-11.42 51.836,-64.54 v -70.85 c 0,-70.89 -6.343,-98.72 -53.129,-148.03 l -81.015,-86.02 c -78.379,-83.55 -107.5,-139.21 -107.5,-223.94 v -158.16 h 374.504 v 117.68",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1695.78,637 v -59.809 c -0.04,-0.421 -0.2,-0.91 -0.2,-1.351 0,-0.508 0.16,-0.981 0.2,-1.418 0.63,-14.793 12.71,-26.59 27.61,-26.871 0.17,0 0.33,-0.11 0.54,-0.11 0.2,0 0.46,0.11 0.69,0.11 h 701.76 c 0.18,0 0.39,-0.11 0.6,-0.11 0.2,0 0.41,0.11 0.62,0.11 15.33,0.281 27.56,12.75 27.67,28.078 0,0.062 0.1,0.109 0.1,0.211 0,0 -0.1,0.109 -0.1,0.211 v 67.691 c 395.05,129.496 690.99,449.678 756.08,839.878 0.15,0.83 0.25,1.6 0.38,2.32 0.24,1.37 0.39,2.61 0.39,3.93 0,15.69 -12.65,28.37 -28.37,28.37 H 960.516 947.145 c -15.774,0 -28.45,-12.68 -28.45,-28.37 l 1.473,-12.76 C 988.527,1083.2 1292.6,761.23 1695.78,637",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2454.62,2472.83 c -9.21,-13.12 -225.3,-324.22 4.83,-575.78 105.54,-115.45 96.38,-217.33 66.25,-286.13 h 147.62 c 29.9,101.59 17.56,229 -102.29,359.94 -169.56,185.37 2.17,435.92 4.75,439.79 20.24,28.59 9.4,65.43 -23.96,82.62 -33.48,17.09 -76.88,7.95 -97.2,-20.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2080.77,1610.92 h 147.67 c 29.85,101.62 17.45,228.97 -102.39,359.94 -169.62,185.39 1.99,435.82 4.7,439.92 20.14,28.46 9.47,65.24 -24.01,82.49 -33.35,17.04 -76.83,7.98 -97.07,-20.44 -9.27,-13.07 -225.54,-324.22 4.8,-575.78 105.54,-115.48 96.35,-217.38 66.3,-286.13",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1564.64,2472.83 c -9.35,-13.12 -225.44,-324.22 4.75,-575.78 105.59,-115.5 96.45,-217.38 66.4,-286.13 h 147.62 c 29.84,101.54 17.5,228.95 -102.44,359.94 -169.62,185.37 2.11,435.92 4.82,439.89 20.06,28.49 9.38,65.33 -24.11,82.52 -33.35,17.19 -76.8,8 -97.04,-20.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1274.23,3721.14 v -174.87 h -60.41 v 359.29 h 60.41 v -157.92 l 65.71,157.92 h 59.35 l -69.95,-161.63 71.55,-197.66 h -63.6 l -63.06,174.87",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1421.04,3905.56 h 144.15 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1594.88,3905.56 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1738.5,3772.02 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1332.52,3204.72 h -58.29 v -158.45 h -60.41 v 359.29 h 60.41 v -152.08 h 58.29 v 152.08 h 60.94 v -359.29 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1600.69,3405.56 v -271.85 c 0,-55.65 -23.85,-91.68 -85.32,-91.68 -63.59,0 -90.09,36.03 -90.09,91.68 v 271.85 h 60.42 v -277.68 c 0,-21.2 8.47,-35.51 29.67,-35.51 21.2,0 29.68,14.31 29.68,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1683.39,3272.02 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1930.36,3238.1 h 85.85 v -191.83 h -43.46 v 39.21 c -7.95,-27.02 -24.91,-43.45 -57.76,-43.45 -51.94,0 -75.78,41.33 -75.78,96.98 v 173.81 c 0,56.18 27.02,96.98 90.62,96.98 66.77,0 86.38,-37.09 86.38,-90.09 v -31.79 h -55.12 v 36.56 c 0,22.26 -8.47,34.98 -30.2,34.98 -21.73,0 -31.27,-15.37 -31.27,-37.09 v -192.9 c 0,-21.73 9.01,-37.1 29.68,-37.1 19.6,0 29.67,11.13 29.67,34.45 v 63.59 h -28.61 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2048.03,3405.56 h 144.14 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2282.27,3356.28 v -111.81 h 20.14 c 20.67,0 29.68,10.59 29.68,29.67 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.29 h 87.97 c 60.94,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe02);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-02.e8909b33caabfb5119100d11f21c3995.svg";
export { ForwardRef as ReactComponent };